import Vue from 'vue'
import Vuex from 'vuex'
import map from './modules/map'
import user from './modules/user'
import query from './modules/query'
import clear from './modules/clear'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    map,
    user,
    query,
    clear
  },
  strict: debug,
})


// WEBPACK FOOTER //
// ./src/store/index.js